export const ShieldCheckIcon = ({ strokeColor = "#5300C9", width = "24", height = "24" }) => {
	return (
		<svg width={width} height={height} viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M10.3503 13.4997L12.5421 15.6915L16.9256 11.308M13.638 3.63672C16.1978 5.90146 19.5388 7.08063 22.9531 6.92439C23.4501 8.61537 23.6022 10.389 23.4003 12.1399C23.1984 13.8909 22.6465 15.5833 21.7776 17.1168C20.9087 18.6502 19.7403 19.9933 18.342 21.0663C16.9438 22.1393 15.3441 22.9202 13.638 23.3627C11.9319 22.9202 10.3322 22.1393 8.93392 21.0663C7.53564 19.9933 6.36731 18.6502 5.49836 17.1168C4.62941 15.5833 4.07758 13.8909 3.87565 12.1399C3.67373 10.389 3.82583 8.61537 4.32291 6.92439C7.73719 7.08063 11.0782 5.90146 13.638 3.63672Z"
				stroke={strokeColor}
				strokeWidth="1.64384"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};
